import { render, staticRenderFns } from "./PaginationNew.vue?vue&type=template&id=7cf8ce6f"
import script from "./PaginationNew.vue?vue&type=script&lang=js"
export * from "./PaginationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports